













import DialogSelectInput from "./DialogSelectInput.vue";
import SelectInput from "./SelectInput.vue";
import { createComponent, watch } from "@vue/composition-api";
import useScreenWidth from "@/shared/useScreenWidth";

interface Props {
  value: any;
}

export default createComponent<Props>({
  components: { SelectInput, DialogSelectInput },
  props: {
    value: { required: true },
  },
  setup(props, ctx) {
    const { width } = useScreenWidth();

    return { width };
  },
});
